//  src/themes/index.js
import { createTheme } from '@mui/material/styles';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const theme = (customization) => {
    const color = colors;

    // DECLARAMOS LAS VARIABLES isDark E isHigh PARA DETERMINAR SI EL TEMA ACTUAL ES OSCURO O DE ALTO CONTRASTE, Y ASÍ AJUSTAR LOS COLORES DE LA APLICACIÓN EN CONSECUENCIA.
    // ESTO PERMITE QUE LOS USUARIOS PUEDAN CAMBIAR ENTRE MODO CLARO, MODO OSCURO Y MODO DE ALTO CONTRASTE, Y QUE LA APLICACIÓN SE ADAPTE AUTOMÁTICAMENTE A ESAS PREFERENCIAS.
    const isDark = customization.navType === 'dark';
    const isHigh = customization.contrastLevel === 'high';

    const themeOption = {
        colors: color,
        heading: isHigh ? (isDark ? '#ffffff' : '#000000') : isDark ? color.darkTextTitle : color.grey900,
        paper: isHigh ? (isDark ? '#000000' : '#ffffff') : isDark ? color.darkPaper : color.paper,
        default: isHigh ? (isDark ? '#121212' : '#f0f0f0') : isDark ? color.darkBackground : color.default,
        background: isHigh ? (isDark ? '#000000' : '#ffffff') : isDark ? color.darkPaper : color.paper,
        darkTextPrimary: isHigh ? (isDark ? '#ffffff' : '#000000') : isDark ? color.darkTextPrimary : color.grey700,
        darkTextSecondary: isHigh ? (isDark ? '#eeeeee' : '#111111') : isDark ? color.darkTextSecondary : color.grey500,
        textDark: isHigh ? (isDark ? '#ffffff' : '#000000') : isDark ? color.darkTextTitle : color.grey900,
        menuSelected: isHigh ? (isDark ? '#ffffff' : '#000000') : isDark ? color.darkSecondaryMain : color.secondaryDark,
        menuSelectedBack: isHigh ? (isDark ? '#333333' : '#dddddd') : isDark ? color.darkSecondaryDark : color.secondaryLight,
        divider: isHigh ? (isDark ? '#888888' : '#000000') : isDark ? color.darkLevel2 : color.grey200,
        customization
    };

    const themeOptions = {
        direction: 'ltr',
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        typography: themeTypography(themeOption)
    };

    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOption);

    return themes;
};

export default theme;
